import { memo, useMemo } from 'react'

import { BottomSheet } from '~/shared/ui/BottomSheet'
import { Button } from '~/shared/ui/Button'
import { Text } from '~/shared/ui/Text'
import { WheelPicker, WheelPickerGroup } from '~/shared/ui/WheelPicker'

import { DEFAULT_MINUTE_STEP, HOUR_OPTIONS, buildMinuteOptions } from './config'
import { formatTimeValue, useTimePickerDraft } from './hooks'
import type { TimePickerSheetProps } from './types'

import styles from './TimePickerSheet.module.scss'

/**
 * Шторка выбора времени: часы + минуты поверх BottomSheet + «Готово» (макет 27).
 * Черновой выбор живёт локально, onChange вызывается только по кнопке.
 */
export const TimePickerSheet = memo(function TimePickerSheet(props: TimePickerSheetProps) {
  const { isOpen, onClose, title, value, onChange, minuteStep = DEFAULT_MINUTE_STEP } = props

  const { draft, setHours, setMinutes } = useTimePickerDraft(isOpen, value, minuteStep)
  const minuteOptions = useMemo(() => buildMinuteOptions(minuteStep), [minuteStep])

  const handleConfirm = () => {
    onChange(formatTimeValue(draft))
    onClose()
  }

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <BottomSheet.Header>
        <Text variant='H2' as='h2'>
          {title}
        </Text>
      </BottomSheet.Header>
      <BottomSheet.Content>
        <WheelPickerGroup>
          <WheelPicker
            options={HOUR_OPTIONS}
            value={String(draft.hours)}
            onChange={(next) => setHours(Number(next))}
          />
          <div className={styles.colon}>
            <Text variant='H3' as='span'>
              :
            </Text>
          </div>
          <WheelPicker
            options={minuteOptions}
            value={String(draft.minutes)}
            onChange={(next) => setMinutes(Number(next))}
          />
        </WheelPickerGroup>
      </BottomSheet.Content>
      <BottomSheet.Footer>
        <Button variant='PRIMARY' width='FULL' text='Готово' onPress={handleConfirm} />
      </BottomSheet.Footer>
    </BottomSheet>
  )
})
